export const allRecordsPaginationOptions = {
  page: 0,
  limit: 0,
};

export const readSurahPaginationLimit = 12;
